<template>
    <v-container>
        <v-layout row wrap>
          <h1>Policies for AddToTheStory</h1>
        </v-layout>
        <v-toolbar>
          <v-toolbar-items>
             <v-btn small  @click='active="Privacy"'>Privacy</v-btn>
             <v-btn small  @click='active="Cookie"'>Cookie</v-btn>
             <v-btn small  @click='active="Terms"'>Terms of Service</v-btn>
          </v-toolbar-items>

        </v-toolbar>
        <CookiePolicy v-if='active=="Cookie"'></CookiePolicy>
        <Privacy v-if='active=="Privacy"'></Privacy>
        <Terms v-if='active=="Terms"'></Terms>

    </v-container>
</template>

<script>
import CookiePolicy from '@/views/policies/CookiePolicy.vue'
import Privacy from '@/views/policies/Privacy.vue'
import Terms from '@/views/policies/TermsOfService.vue'

export default {
  name: 'Policies',
  components: {
    CookiePolicy, Privacy, Terms
  },
  data: () => ({
    active: 'Cookie'
  }),
  computed: {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
